import styled from 'styled-components';
import { OptionsSelectStyled } from '../OptionsSelectStyled';
import { rem } from 'polished';

export const OptionsSelectStyledAP = styled(OptionsSelectStyled)``;
